import { GetterNames } from './keys'
import { PatientNoteState } from './types'
import { FlatAPIData, flattenJsonApiResponse } from '@/store/utils/converter'
import { LOOK_BACK_DAYS_FOR_NOTES } from '@/utils/constants'
import moment from 'moment-timezone'
import * as R from 'ramda'
import { PatientNoteAttributes } from '@/jsonapi/PatientNotes'

export type FlatPatientNote = FlatAPIData<PatientNoteAttributes>

/* tslint:disable:no-shadowed-variable */
export const getters = {
  [GetterNames.patientNotes]: (state: PatientNoteState): FlatPatientNote[] => {
    return state.patientNotes.map(flattenJsonApiResponse)
  },
  [GetterNames.patientRecentNotes]: (state: PatientNoteState, getters): FlatPatientNote[] => {
    const lookBackTimestamp = moment()
      .add(-LOOK_BACK_DAYS_FOR_NOTES, 'days')
      .valueOf()
    return getters[GetterNames.patientNotes]
      .filter(patientNote => patientNote.createdTimestamp >= lookBackTimestamp)
      .sort((a, b) => b.createdTimestamp - a.createdTimestamp)
  },
  [GetterNames.patientRecentNotesGroupByPatientId]: (state, getters): { [index: string]: FlatPatientNote[] } => {
    return R.groupBy<FlatPatientNote>(patientNote => patientNote.patientId, getters[GetterNames.patientRecentNotes])
  },
}
